// @flow
import { createFormReducer } from 'redux-pure-form';
import type { Reducer } from 'redux';

import { ADD_CARD, DELETE_CARD } from './card.const.js';

import omit from '../utils/omit.js';

export const cards = (state: $ElementType<ReduxState, 'cards'> = {}, action: Action) => {
  switch (action.type) {
    case ADD_CARD:
      return {
        ...state,
        [action.payload.card.id]: action.payload.card
      };
    case DELETE_CARD:
      return omit(state, action.payload.card.id);
    default:
      return state;
  }
};

// export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;
